module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_19_16.300d4661.jpg";